import { render, staticRenderFns } from "./barsh.vue?vue&type=template&id=004140ce&"
import script from "./barsh.vue?vue&type=script&lang=js&"
export * from "./barsh.vue?vue&type=script&lang=js&"
import style0 from "./barsh.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports